import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations'
import { TranslationMode } from 'cng-common/features/translations/configs'
import { selectTranslationMode } from 'cng-common/features/translations/selectors'

export const CockpitFilterLabel = ({
  text,
  placeholderOnly = false,
}: {
  text: string
  placeholderOnly?: boolean
}) => {
  const translationMode = useSelector(selectTranslationMode)

  if (placeholderOnly && translationMode !== TranslationMode.Edit) return null

  return <Translation text={text} span />
}
